"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const blankBackground_webp_1 = __importDefault(require("assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("components/onboarding/HeroImage"));
const OnboardingForm_1 = __importDefault(require("components/onboarding/OnboardingForm"));
const registerCopy_1 = require("copy/registerCopy");
const StyledImageBackground_1 = require("components/onboarding/styles/StyledImageBackground");
const Register = () => {
    const linkProps = {
        preface: registerCopy_1.registerCopy.linkPreface,
        href: registerCopy_1.registerCopy.linkHref,
        prompt: registerCopy_1.registerCopy.linkPrompt
    };
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'register', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { contactLink: linkProps, cta: registerCopy_1.registerCopy.cta, header: registerCopy_1.registerCopy.header, inputs: null, onFormSubmit: (event) => {
                event.preventDefault();
                window.open(env.REDO_APP_URL, '_blank', 'noopener,noreferrer');
            }, textPrompt: registerCopy_1.registerCopy.body }),
        react_1.default.createElement(HeroImage_1.default, { header: registerCopy_1.registerCopy.heroHeader, subheader: registerCopy_1.registerCopy.heroSubHeader })));
};
exports.default = Register;
